/* Cherry Twist — cart AOV tools: free-delivery progress + "complete the set" cross-sell.
   Self-contained. Delete this file and its <script> tag in layout/theme.liquid to remove. */
(function () {
  var THRESHOLD = 10000;             // pence — free UK delivery over £100
  var MAX_SUGGESTIONS = 3;
  var catalogue = null;

  function money(p) {
    return '£' + (p / 100).toFixed(2).replace(/\.00$/, '');
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function getCatalogue() {
    if (catalogue) return Promise.resolve(catalogue);
    return fetch('/products.json?limit=50', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { catalogue = j.products || []; return catalogue; });
  }

  /* ---------- free-delivery progress ---------- */
  function progress(cart, host) {
    var el = host.querySelector('.ct-ship');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ct-ship';
      host.insertBefore(el, host.firstChild);
    }
    var left = THRESHOLD - cart.total_price;
    if (left <= 0) {
      el.innerHTML = '<p class="ct-ship__win"><span class="ct-ship__tick">✓</span> Free UK delivery unlocked</p>';
      el.classList.add('is-win');
      return;
    }
    el.classList.remove('is-win');
    var pct = Math.max(4, Math.min(100, Math.round((cart.total_price / THRESHOLD) * 100)));
    el.innerHTML =
      '<p class="ct-ship__msg">You are <strong>' + money(left) + '</strong> away from free UK delivery</p>' +
      '<div class="ct-ship__track"><div class="ct-ship__fill" style="width:' + pct + '%"></div></div>';
  }

  /* ---------- complete the set ---------- */
  function crossSell(cart, host) {
    if (host.dataset.xsell) return;      // set synchronously: the fetch below is async,
    host.dataset.xsell = '1';            // so two mounts could otherwise both get through
    getCatalogue().then(function (prods) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.handle] = true; });
      var picks = prods.filter(function (p) { return !inCart[p.handle]; }).slice(0, MAX_SUGGESTIONS);
      if (!picks.length) return;

      var box = document.createElement('div');
      box.className = 'ct-xsell';
      var html = '<p class="ct-xsell__h">Complete the set</p><div class="ct-xsell__list">';
      picks.forEach(function (p) {
        var v = p.variants && p.variants[0];
        if (!v) return;
        var img = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src.split('?')[0] + '?width=120' : '';
        var can = v.available;
        html +=
          '<div class="ct-xsell__item">' +
            (img ? '<img class="ct-xsell__img" src="' + img + '" alt="" loading="lazy">' : '') +
            '<div class="ct-xsell__info">' +
              '<span class="ct-xsell__t">' + p.title + '</span>' +
              '<span class="ct-xsell__p">' + money(Math.round(parseFloat(v.price) * 100)) + '</span>' +
            '</div>' +
            (can
              ? '<button type="button" class="ct-xsell__add" data-v="' + v.id + '">Add</button>'
              : '<span class="ct-xsell__soon">Coming soon</span>') +
          '</div>';
      });
      html += '</div>';
      box.innerHTML = html;
      host.appendChild(box);

      box.addEventListener('click', function (e) {
        var b = e.target.closest('.ct-xsell__add');
        if (!b) return;
        b.disabled = true; b.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(b.dataset.v), quantity: 1 }] })
        }).then(function (r) { return r.json(); })
          .then(function () { window.location.reload(); })
          .catch(function () { b.disabled = false; b.textContent = 'Add'; });
      });
    });
  }

  function mount() {
    var anchor = document.getElementById('checkout');
    if (!anchor) return;
    var host = document.querySelector('.ct-aov');
    if (!host) {
      host = document.createElement('div');
      host.className = 'ct-aov';
      anchor.parentNode.insertBefore(host, anchor);
    }
    getCart().then(function (cart) {
      if (!cart.items || !cart.items.length) { host.remove(); return; }
      progress(cart, host);
      crossSell(cart, host);
    });
  }

  var pending = null, observer;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      observer.disconnect();                       // don't react to our own insertions
      mount();
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }, 120);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('cart:update', schedule);
  observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
